import {
  FbList,
  FbListItem,
  FbListItemText,
  FbTypeography,
} from "@flexibees/core";
import React from "react";
import { COLORS } from "../../constants/colors";
import { CustomCheckbox } from "./CustomCheckbox";

const ListItems = ({ classes, data, onChange, checked }) => {
  return (
    <FbList className={classes.root}>
      {!data.length && (
        <FbTypeography
          type="body2"
          style={{ color: COLORS.BLACK, textAlign: "center" }}
        >
          No Data
        </FbTypeography>
      )}
      {data.map((item) => {
        const labelId = `checkbox-list-label-${item.id}`;
        return item ? (
          <FbListItem
            key={item.id || item}
            role={undefined}
            dense
            button
            onClick={onChange(item.id || item)}
          >
            <CustomCheckbox
              edge="start"
              checked={checked.indexOf(item.id || item) !== -1}
              tabIndex={-1}
              disableRipple
              inputProps={{ "aria-labelledby": labelId }}
            />

            <FbListItemText
              id={labelId}
              disableTypography
              primary={
                <FbTypeography type="body2" style={{ color: COLORS.BLACK }}>
                  {typeof item === "object"
                    ? item.tag_name || item.first_name
                    : item}
                </FbTypeography>
              }
            />
          </FbListItem>
        ) : null;
      })}
    </FbList>
  );
};

export default ListItems;
